import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { AddVehiclePage } from './add-vehicle';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [AddVehiclePage],
  imports: [IonicPageModule.forChild(AddVehiclePage), ComponentsModule],
})
export class AddVehiclePageModule {}



// WEBPACK FOOTER //
// ./src/pages/add-vehicle/add-vehicle.module.ts